import { render, staticRenderFns } from "./LaldClinicalCase.vue?vue&type=template&id=1960ca62&scoped=true"
import script from "./LaldClinicalCase.vue?vue&type=script&lang=js"
export * from "./LaldClinicalCase.vue?vue&type=script&lang=js"
import style0 from "./LaldClinicalCase.vue?vue&type=style&index=0&id=1960ca62&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1960ca62",
  null
  
)

export default component.exports